@if (isLoading) {
    <div class="loading">
        <img src="assets/images/loading.gif" alt="">
        <div class="message">Loading data, please wait a moment</div>
    </div>
}
